import React from "react";
import PropTypes from "prop-types";
import { Paper, Typography, LinearProgress, Box } from "@mui/material";
import { Bar } from "react-chartjs-2";
import { CHART_COLORS } from "./chartTheme";
import { formatCurrency } from "./formatters";

// Categorical bar chart card — products, categories, geography, yearly comparison.
const BarChartCard = ({
  title,
  labels = [],
  series = [],
  label = "Value",
  horizontal = false,
  color,
  loading,
  height = 300,
  currency = false,
}) => {
  const hasData = labels.length > 0 && series.length > 0;

  const data = {
    labels,
    datasets: [
      {
        label,
        data: series,
        backgroundColor: color || CHART_COLORS[0],
      },
    ],
  };

  const valueAxis = horizontal ? "x" : "y";

  const options = {
    indexAxis: horizontal ? "y" : "x",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: currency
        ? {
            callbacks: {
              label: (context) => formatCurrency(horizontal ? context.parsed.x : context.parsed.y),
            },
          }
        : undefined,
    },
    scales: currency
      ? {
          [valueAxis]: {
            ticks: {
              callback: (value) => formatCurrency(value),
            },
          },
        }
      : undefined,
  };

  return (
    <Paper sx={{ padding: "1rem" }}>
      <Typography sx={{ fontSize: "16px", fontWeight: 700, marginBottom: "1rem" }}>
        {title}
      </Typography>
      {loading && <LinearProgress />}
      {!loading && !hasData && (
        <Typography sx={{ color: "#6B7280", fontSize: "13px", padding: "2rem 0", textAlign: "center" }}>
          No data available for this range.
        </Typography>
      )}
      {!loading && hasData && (
        <Box sx={{ height }}>
          <Bar options={options} data={data} />
        </Box>
      )}
    </Paper>
  );
};

BarChartCard.propTypes = {
  title: PropTypes.string.isRequired,
  labels: PropTypes.array,
  series: PropTypes.array,
  label: PropTypes.string,
  horizontal: PropTypes.bool,
  color: PropTypes.string,
  loading: PropTypes.bool,
  height: PropTypes.number,
  currency: PropTypes.bool,
};

export default BarChartCard;
